export default "__VITE_ASSET__BcDNoeRR__"